import { useCallback } from 'react';
import { appRoutes, ROUTING_TAB } from '../../constants/appRoutes';
import useSweepNavigate from '../../navigation-utils/useSweepNavigate';
import { useSweepParams } from '../../navigation-utils/useSweepParams';
import { readableUUID } from '../../navigation-utils/readableUUID';
import { useSelector } from 'react-redux';
import { selectUserAccountId } from '../../reducers/userInfoReducer';

export enum RoutingTabs {
  assignment = 'assignment',
  scheduled = 'scheduled',
  members = 'members',
  groups = 'groups',
  territories = 'territories',
}

export const useRoutingTabs = () => {
  const { routingTab } = useSweepParams<{
    routingTab: RoutingTabs;
    crmOrgId: string;
  }>();
  const { navigate } = useSweepNavigate();
  const userAccountId = useSelector(selectUserAccountId) ?? '';

  const changeTab = useCallback(
    (destinationTab: RoutingTabs, crmOrgId: string) => {
      navigate(
        `${appRoutes.routing.route}/${readableUUID(crmOrgId)}/${readableUUID(userAccountId)}/${ROUTING_TAB}/${destinationTab}`,
        {
          replace: true,
        },
      );
    },
    [navigate, userAccountId],
  );
  const clearTab = useCallback(
    (crmOrgId: string) => {
      navigate(
        `${appRoutes.routing.route}/${readableUUID(crmOrgId)}/${readableUUID(userAccountId)}`,
        { replace: true },
      );
    },
    [navigate, userAccountId],
  );

  return {
    routingTab,
    changeTab,
    clearTab,
  };
};
